import { useQuery } from '@tanstack/react-query';
import { getAppData } from '../../lib/storage';
import { defaultThemeConfig } from '../../lib/theme';
import type { ThemeConfig } from '@ext-bookmark/shared/types';

/**
 * 获取主题配置
 */
export function useThemeConfig() {
  return useQuery({
    queryKey: ['theme', 'config'],
    queryFn: async (): Promise<ThemeConfig> => {
      try {
        const data = await getAppData();
        const theme = data.theme || 'light';
        const savedThemeConfig = data.themeConfig;
        
        if (savedThemeConfig) {
          // 如果存储的配置是旧格式（扁平结构），转换为新格式
          if ('sidebar' in savedThemeConfig) {
            return savedThemeConfig;
          } else {
            // 转换为新格式
            return {
              mode: theme,
              sidebar: {
                width: (savedThemeConfig as any).sidebarWidth || defaultThemeConfig.sidebar.width,
                opacity: (savedThemeConfig as any).sidebarOpacity || defaultThemeConfig.sidebar.opacity,
                backgroundColor: (savedThemeConfig as any).sidebarBackgroundColor || defaultThemeConfig.sidebar.backgroundColor,
                textColor: (savedThemeConfig as any).sidebarTextColor || defaultThemeConfig.sidebar.textColor,
                activeColor: (savedThemeConfig as any).sidebarActiveColor || defaultThemeConfig.sidebar.activeColor,
                hoverColor: (savedThemeConfig as any).sidebarHoverColor || defaultThemeConfig.sidebar.hoverColor,
                borderColor: (savedThemeConfig as any).sidebarBorderColor || defaultThemeConfig.sidebar.borderColor,
              },
              components: {},
            };
          }
        }
        
        return { ...defaultThemeConfig, mode: theme };
      } catch (error) {
        console.error('[useThemeConfig] 加载主题配置失败:', error);
        return defaultThemeConfig;
      }
    },
    staleTime: Infinity, // 主题配置很少变化，可以长期缓存
    gcTime: Infinity,
    retry: 1,
    retryDelay: 500,
  });
}
